(function() {
  const packs = localStorage.getItem('clawz_quiz_state');
  if(packs) {
    const parsedPacks = JSON.parse(packs);
    const cats = parsedPacks.cats;
    // const catDetails = parsedPacks.catDetails;
    // const foodTypesArray = [];
    // catDetails.forEach(cat => {
    //   cat.foodType.forEach(foodType => {
    //     // remove duplicates
    //     if (!foodTypesArray.includes(foodType)) {
    //         foodTypesArray.push(foodType);
    //     }
    //   });

    // });
    // console.log({foodTypesArray});
    const orderNote = cats > 3 ? `cat-3` : `cat-${cats}`;
    // setTimeout(() => {
    //     const foodTypeLength = foodTypesArray.length;
    //     const baseFoods = Math.floor(7 / foodTypeLength);
    //     const remainder = 7 % foodTypeLength;

    //   foodTypesArray.forEach((foodType, index) => {

    //     const imgAlt = document.querySelector(`img[alt^="${foodType}"]`)
    //     const imgAltParent = imgAlt.closest('.sc-4cc86f25-0');
    //     const imgAltInput = imgAltParent.querySelector('.sc-51d4772f-1');
    //     const nextButtonSibling = imgAltInput.nextElementSibling;
    //     console.log(nextButtonSibling, 'nextButtonSibling');
    //     nextButtonSibling.click();
    //     if(index < remainder) {
    //         imgAltInput.innerText = baseFoods + 1;
    //     } else {
    //         imgAltInput.innerText = baseFoods;
    //     }
    //   })
  
    // }, 4000);

    // check if url is Skio
    const url = window.location.href;
    if(url.includes('custom-tools/dynamic-box')) {
      // console.log('Skio', orderNote);
      addOrderNote(orderNote);
    }
  }


  function addOrderNote(orderNote) {
    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          note: orderNote 
        })
      })
      .then(response => {
        if (response.ok) {
          console.log('Order note added successfully.');
          // Optional: You could reload the page to see the change
          // location.reload(); 
        }
      })
      .catch((error) => {
        console.error('Error adding order note:', error);
      });
  }
})();